import React from 'react';

interface MessageProps {
  error?: boolean;
  success?: boolean;
  info?: boolean;
  warning?: boolean;
  icon?: string;
  header?: string;
  content?: string | React.ReactNode;
  list?: string[];
  onDismiss?: () => void;
  className?: string;
}

const TailwindMessage: React.FC<MessageProps> = ({
  error,
  success,
  info,
  warning,
  icon,
  header,
  content,
  list,
  onDismiss,
  className = ''
}) => {
  const getBackgroundColor = () => {
    if (error) return 'bg-red-50 border-red-400';
    if (success) return 'bg-green-50 border-green-400';
    if (info) return 'bg-blue-50 border-blue-400';
    if (warning) return 'bg-yellow-50 border-yellow-400';
    return 'bg-gray-50 border-gray-400';
  };

  const getTextColor = () => {
    if (error) return 'text-red-700';
    if (success) return 'text-green-700';
    if (info) return 'text-black-700';
    if (warning) return 'text-yellow-700';
    return 'text-gray-700';
  };

  const getIconColor = () => {
    if (error) return 'text-red-400';
    if (success) return 'text-green-400';
    if (info) return 'text-black-400';
    if (warning) return 'text-yellow-400';
    return 'text-gray-400';
  };

  return (
    <div className={`rounded-lg border p-4 ${getBackgroundColor()} ${className}`} role="alert">
      <div className="flex items-start">
        {icon && (
          <div className={`flex-shrink-0 ${getIconColor()}`}>
            <i className={`${icon} text-xl`}></i>
          </div>
        )}
        <div className="ml-3 w-full">
          {header && <h3 className={`text-sm font-medium ${getTextColor()}`}>{header}</h3>}
          {content && <div className={`mt-2 text-sm ${getTextColor()}`}>{content}</div>}
          {list && list.length > 0 && (
            <ul className={`list-disc list-inside mt-2 text-sm ${getTextColor()}`}>
              {list.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          )}
        </div>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className={`ml-auto -mx-1.5 -my-1.5 rounded-lg focus:ring-2 p-1.5 inline-flex h-8 w-8 ${getTextColor()}`}
          >
            <span className="sr-only">Dismiss</span>
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default TailwindMessage;
